export default __webpack_public_path__ + "static/media/mike.2245a809.png";